module.exports = __webpack_public_path__ + "assets/img/fujitsu.703bf422.png";